import { apiInstanceFetch } from "../../../util/api";
import axios from "axios";
import * as ActionType from "./chat.type";
import { setToast } from "../../../util/toast";

// Get all conversations
export const getConversations = (start, limit) => (dispatch) => {
  apiInstanceFetch
    .get(`chat/admin/all?start=${start}&limit=${limit}`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_CONVERSATIONS,
        payload: {
          data: res.conversations,
          totalConversations: res.totalConversations
        },
      });
    })
    .catch((error) => console.error(error));
};

// Get conversation details with messages
export const getConversationDetails = (conversationId) => (dispatch) => {
  apiInstanceFetch
    .get(`chat/admin/details?conversationId=${conversationId}`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_CONVERSATION_DETAILS,
        payload: {
          conversation: res.conversation,
          messages: res.messages,
          totalMessages: res.totalMessages,
        },
      });
    })
    .catch((error) => console.error(error));
};

// Block/Unblock conversation
export const blockConversation = (conversationId) => (dispatch) => {
  axios
    .patch(`chat/admin/block?conversationId=${conversationId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.BLOCK_UNBLOCK_CONVERSATION,
          payload: { data: res.data.conversation, id: conversationId },
        });
        setToast("success", res.data.message);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message));
};

// Delete message
export const deleteMessage = (messageId, conversationId) => (dispatch) => {
  axios
    .delete(`chat/admin/deleteMessage?messageId=${messageId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_MESSAGE,
          payload: messageId,
        });
        setToast("success", "Message deleted successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message));
};

// Get chat statistics
export const getChatStats = () => (dispatch) => {
  apiInstanceFetch
    .get(`chat/admin/stats`)
    .then((res) => {
      dispatch({
        type: ActionType.GET_CHAT_STATS,
        payload: res.stats,
      });
    })
    .catch((error) => console.error(error));
};

// Clear conversation details
export const clearConversationDetails = () => (dispatch) => {
  dispatch({
    type: ActionType.CLEAR_CONVERSATION_DETAILS,
  });
};
